<template>
  <div>
    <div class="v-exhibits-detail-page"
      style="background: #fff;"
      v-if="this.exhibitInfo.requireRegisterVisitor == false && this.exhibitInfo.requireAddContactPerson  == false">
      <div class="v-exhibits-header">
        <v-exhibits-detail class="v-detail" :vData="exhibitInfo" @todoCallback="todoCallback">
          <template v-slot:footer><span></span></template>
        </v-exhibits-detail>
      </div>
      <div class="v-exhibits-content">
        <div class="v-exhibits-base-info">
          <div class="baseInfo-title">{{$t('baseInfo')}}</div>
          <el-row :gutter="30">
            <template v-if="exhibitInfo && exhibitInfo.details">
              <template v-for="item in exhibitInfo.details">
                <el-col :span="12" class="detail-questionTag" :key="item.keyword"
                  v-if="item.showValue.content && (['productName','productIntro', 'productEnIntro'].indexOf(item.keyword) == -1)">
                  <span>{{ item.showValue.title }}：</span>
                  <label class='theme-label'>
                    <a :href="item.showValue.content" v-if="item.keyword == 'webUrl'" target="view_window">{{
                      $t('finds.enterDetail') }}</a>
                    <template v-else>{{ item.showValue.content }}</template>
                  </label>
                </el-col>
              </template>
            </template>
            <template v-if="exhibitInfo && exhibitInfo.questionList">
              <el-col :span="12" class="detail-questionTag" v-for="item in exhibitInfo.questionList" :key="item.id">
                <span>{{ item.aliasName }}：</span>
                <template v-for="(aItem, index) in item.answerList">
                  <label class='theme-label' :key="aItem.id" v-if="index < 3">{{ aItem.aliasName }}</label>
                </template>
              </el-col>
            </template>
          </el-row>
        </div>
        <div class="v-exhibits-base-info" v-if="exhibitInfo.productIntro">
          <div class="baseInfo-title">{{$t('finds.productDetail')}}</div>
          <div class="p">{{ exhibitInfo.productIntro }}</div>
        </div>
      </div>
      <div class="v-exhibits-piic" v-if="exhibitInfo.longImage && exhibitInfo.longImage.length > 0">
        <div v-for="(item, index) in exhibitInfo.longImage" :key="index">
          <el-image :src="item" lazy></el-image>
        </div>
      </div>
      <div class="v-exhibits-content m-b-0" v-if="dataList.length > 0">
        <div class="bg-fd hot-product-block">
          <div class="hot-head">
            <strong>{{$t("guesssYouLike")}}</strong>
          </div>
          <el-row class="ShangWai" :gutter="30">
            <el-col class="ShangList" v-for="(item, index) in dataList" :key="item.id" :span="6">
              <ExhibitCard class="v-exhibits-card" :vData="item" :index="index" @callback="vExibitsCallback" />
            </el-col>
          </el-row>
        </div>
      </div>
      <ChatWithExhibitor @invite="submitInvite" :action="action" />

      <winDialog :dialogShow.sync="dialog" :loading="loading" :title='$t("order.title")'
        :subTitle='$t("order.subTitle")' :cancel="cancel" :sure="submitOrder">
        <template v-slot:bodyContent>
          <el-form :disabled="loading" :model="orderForm" :rules="rules" ref="orderForm" label-position="top"
            label-width="100px" class="order-form">
            <el-form-item prop="employeeId" size="small">
              <SalesmanDialog ref="salesmanComponent" :employeeId.sync="orderForm.employeeId"
                :exhibitorId="exhibitInfo.exhibitorId" />
            </el-form-item>

            <el-form-item prop="number" :label="$t('order.number')" size="small">
              <el-input type="number" v-model="orderForm.number" class="input-number"
                :placeholder="$t('order.numberPlaceholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('order.remarks')" prop="remarks" size="small">
              <el-input type="textarea" v-model="orderForm.remarks" :placeholder="$t('order.remarksPlaceholder')"
                maxlength="400" show-word-limit rows="5"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </winDialog>


    </div>
    <div class="productTipsDialog">
      <el-dialog :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false" :before-close="handleClose">
        <div slot="title" class="header-title">
          <div>
            <p class="dialogTips font-size-18">{{ $t('finds.productDetail') }}</p>
          </div>
        </div>
        <div class="dialogConcant" v-if="dialogType == 1">
          <p>{{ $t('For details, please invite exhibitors') }}<el-button size="mini" @click="goInvitation()">{{
              $t('Invite now') }}</el-button></p>
          <div class="dialogConcantDiv">
            <p>{{ $t('Or, enter the invitation code and watch') }}</p>
            <el-input v-model="inviteCode" maxlength="10" size="mini"
              :placeholder="$t('Please enter the invitation code')"></el-input><el-button type="primary" size="mini"
              @click="addInviteCode(exhibitInfo.exhibitorId)">{{ $t('determine') }}</el-button>
          </div>
        </div>
        <div class="dialogConcant" v-else-if="dialogType == 2 && $store.state.config.hideElement">
          <div class="dialogConcantDiv text-right">
            <p class="text-left">{{ $t('Unregistered users can only see limited products. Please register to view more.') }}</p>
            <el-button class="margin-t-24" type="primary" @click="goLogin">{{ $t('login') }}</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getProductDetail } from '@/api'
import { addOrder } from '@/api/potentialOrder'
import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import { mapGetters } from 'vuex'
import vExhibitsDetail from '@/components/vExhibitsDetail'
import winDialog from '@/components/dialog/dialog'
import ExhibitCard from '@/components/card/ExhibitCard'
import { inviteOrIM } from '@/utils/function'
import SalesmanDialog from '@/components/dialog/Salesman'
import { addContactPersonByInviteCode } from '@/api/index'

export default {
  //客商版 展品详情
  name: 'findExhibitDetail',
  components: {
    vExhibitsDetail,
    winDialog,
    ExhibitCard,
    SalesmanDialog
  },
  mixins: [eventMixin, inviteMixin],
  props: ['id'],
  data() {
    const checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('order.numberPlaceholder')))
      }
      setTimeout(() => {
        if (!Number.isInteger(parseInt(value))) {
          callback(new Error(this.$t('Please enter a number value')))
        } else {
          if (value > 99999) {
            callback(new Error(this.$t('Amount should less than 99999')))
          } else {
            callback()
          }
        }
      }, 1000)
    }
    return {
      inviteCode:'',
      dialogType:1,
      dialogVisible:false,
      exhibitInfo: {},
      selectedList: {},
      dataList: [],
      exhibitorId: '',
      dialog: false,
      loading: false,
      orderForm: {
        number: '',
        remarks: '',
        employeeId: ''
      },
      rules: {
        employeeId: [
          { required: true, message: this.$t('order.employeePlaceholder'), trigger: 'change' },
        ],
        number: [
          { required: true, message: this.$t('order.numberPlaceholder'), trigger: 'blur' },
          { validator: checkAmount, trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: this.$t('order.remarksPlaceholder'), trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  mounted() {
    if (this.id) {
      window.PC.$RangersEventDetail(this.id, {
      ...(this.$route.query || {})
      }, 'product')
      this.getDetail()
    }
  },

  watch: {
    'orderForm.employeeId': {
      handler() {
        if (this.orderForm.employeeId) {
           this.$refs['orderForm'].validate()
        }
      }
    }
  },

  methods: {
    goLogin() {
      this.$store.commit('SET_SUBJECTTYPE', '')
      this.loginSource({'source': true})
    },
    handleClose() {

    },
    goInvitation() {
      this.dialogVisible = false
      this.$router.push(`/find-exhibitor/detail/${this.exhibitInfo.exhibitorId}`)
    },
    addInviteCode(id) {
      if(this.inviteCode !=''){
        addContactPersonByInviteCode({ exhibitorId: String(id), inviteCode: String(this.inviteCode),type: 2 }).then(res => {
          if (res.data.code == 1000 && res.data.data == true) {
            this.inviteCode = ''
            this.getDetail()
            this.dialogVisible = false
          } else {
            this.$notify({
              message: this.$t('Invitation code error'),
              type: 'warning'
            });
          }
        })
      } else {
        this.$notify({
          message: this.$t('Please enter the invitation code'),
          type: 'warning'
        });
      }
      
    },
    // 意向订单取消
    cancel(done) {
      window.PC.$RangersEvent("exhibitdetails_cancelbutton_click", {
        exhibitor_id: this.exhibitInfo.exhibitorId,
        exhibit_id: this.id,
        employee_id: this.orderForm.employeeId
      })
      done()
    },
    // 意向订单提交
    submitOrder(done) {
      console.log(this.orderForm.employeeId)
      this.$refs['orderForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          
          addOrder({
            exhibitorId: this.exhibitInfo.exhibitorId,
            employeeId: this.orderForm.employeeId,
            productId: this.$route.params.id,
            num: parseInt(this.orderForm.number),
            remark: this.orderForm.remarks
          }).then(() => {
            this.loading = false
            this.$notify({
              title: this.$t('tip.success'),
              message: this.$t('Submit potential order successfully'),
              type: 'success'
            })
            inviteOrIM({
              acceptId: this.exhibitInfo.exhibitorId,
              acceptSubjectType: 'ACTOR',
              url:location.href,
              interateType: this.language === 'en' ? 'INTENTION_ORDER_EN' : 'INTENTION_ORDER_CN',
              language: this.language
            })
            this.$refs['salesmanComponent'].emptySeleledEmployee()
            this.orderForm ={
              number: '',
              remarks: '',
              employeeId: ''
            }
            window.PC.$RangersEvent("exhibitdetails_orderconfirmationbutton_click", {
                exhibitor_id: this.exhibitInfo.exhibitorId,
                exhibit_id: this.id,
                employee_id: this.orderForm.employeeId
            })
            done()
          })
        } else {
          return false;
        }
      });
    },

    // setEmployeeId(id) {
    //   this.orderForm.employeeId = id
    // },
    // 获取详情
    getDetail() {
      const loading = this.$loading({
        lock: true
      })
      getProductDetail({
        id: this.id,
        showType: 'PRODUCT_DETAILS'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            this.exhibitInfo = res.data
            let list = []
            if (this.exhibitInfo.piiic) {
              this.exhibitInfo.piiic.split(',').forEach(element => {
                if (element) {
                  list.push(element)
                }
              })
              this.exhibitInfo.longImage = list
            }
            // 需要预登记
            if(this.exhibitInfo.requireRegisterVisitor) {
              this.dialogVisible = true
              this.dialogType = 2
            }
            if(this.exhibitInfo.requireAddContactPerson) {
              this.dialogVisible = true
              this.dialogType = 1
            }
            this.exhibitorId = this.exhibitInfo.exhibitorId
            this.dataList    = res.data.productList || []
          }
        }).finally(() => {
          loading.close()
        })
    },
    // 详情收藏
    detailCollected() {
      this.collectEvent(
        {
          id: this.exhibitInfo.collectionId,
          deleted: this.exhibitInfo.collected,
          collectionSubjectType: 'PRODUCT',
          collectionSubjectId: this.exhibitInfo.id
        },
        status => {
          this.exhibitInfo.collected = status
        }
      )
    },
    // 详情邀约
    detailInviteEventExh() {
      this.inviteEventExh(
        { ...this.exhibitInfo },
        status => {
          this.exhibitInfo['invite'] = status
        },
        'products'
      )
    },
    // 详情消息
    detailMessage(data) {
      data.atrName = data.exhibitorName
      // data.exhibitorId = data.actorId
      data.exhibitorId = this.exhibitorId
      this.msgEventExh(data, null, 'products')
    },
    // 详情直播
    detailLive(data) {
      this.liveEvent(data.liveId)
    },
    // 展品卡片回调
    vExibitsCallback(eData) {
      console.log(eData)
      switch (eData.type) {
        case 'message':
          this.detailMessage(eData.data)
          break
        case 'invite':
          if (eData.data.invite) return
          this.inviteEventExh(eData.data, eData.index, 'products', 'exhibitDetial')
          break
        case 'details':
          this.pageDetail(eData.data, 'product', true, 'exhibitDetial')
          break
        case 'collect':
          this.collectEvent(
            {
              id: eData.data.collectionId,
              deleted: eData.data.collected,
              collectionSubjectType: 'PRODUCT',
              collectionSubjectId: eData.data.id
            },
            eData.index, 'exhibitDetial')
          break
        case 'live':
          this.detailLive(eData.data)
          break
      }
    },
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
      this.dataList.forEach(item => {
        item['invite'] = status
      })
      this.detail['invite'] = status
    },
    // 详情回调
    todoCallback(todo, data) {
      switch(todo) {
        case 'live':
          this.detailLive(data)
          break
        case 'collect':
          this.detailCollected()
          break
        case 'message':
          this.detailMessage(data)
          break
        case 'invite':
          this.detailInviteEventExh()
          break
        case 'order':
          if (!this.isLoginFn()) return
          if (!this.todoPrission()) return

          window.PC.$RangersEvent("exhibitdetails_placeanorderbutton_click", {
            exhibitor_id: data.exhibitorId,
            exhibit_id: this.id
          })
          this.dialog = true
          break
      }
    }
  }
}
</script>

<style lang="stylus">
  .order-form {
    margin: 0 auto;
    width: 400px;

    .el-form-item__label {
      padding-bottom: 0
    }
  }

  .v-exhibits-piic {
    .el-image__inner {
      width: auto;
      max-width: 100%;
    }
  }
  
</style>
<style lang="stylus" scoped>

.v-exhibits-header{
    width:100%;
    padding:0px 0 0;
    .v-detail{
        width:100%;
        padding: 0 15px;
        max-width:$container-width;
        margin:0 auto;

        >>> .v-detail-right{
          padding-bottom: 0;
        }
    }

    .d-pv-live{
      margin-bottom: 12px;

      &>div{
        float: left;
        line-height: 20px;
        font-size: 16px;
        color: $color-main;

        &:first-child{
          margin-right: 24px;
          color: $color-black-45
        }
      }
    }

    .detail-questionTag {
      color: $color-black-65
    }

    .v-tool-block{
      margin-bottom: 5px;
      color: $color-black-65

      .v-pointer {
        font-size: 13px;
      }
    }

    .v-company {
      margin-top: 20px;
      .v-company-head{
        float: left;
        line-height: 20px;
        font-size: 18px;
      }

      .v-company-info{
        margin-top: 4px;
        padding-left: 66px;

        &>div:first-child{
          color: $color-black-85
        }

        &>div:last-child{
          margin-top: 6px;
          font-size: 16px;
          color: $color-black-65

          * {
            margin-right: 8px;
          }
        }
      }
    }
}

.v-exhibits-content{
    margin: 30px auto;
    width:100%;
    background: $color-white;

    .v-exhibits-base-info {
      position relative;
      padding: 8px 15px;
      max-width: $container-width;
      margin: 0 auto;

      // & + .v-exhibits-base-info{
      //   &:before{
      //     content: '';
      //     position: absolute;
      //     top: 0;
      //     left: 15px;
      //     right: 15px;
      //     height: 1px;
      //     border-top: 1px solid $border-color-e5;
      //   }
      // }
    }

    .baseInfo-title {
      margin-bottom: 8px;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }
}

.v-exhibits-piic {
    margin: 0 auto;
    margin-bottom: 30px;
    padding: 0 15px;
    max-width: $container-width;
    text-align: center;
}

.hot-product-block {
  max-width: $container-width;
  margin: 0 auto;
  padding: 0 15px 25px;

  .hot-head {
    position: relative;
    padding: 24px 0;
    padding-left: 12px;
    line-height: 16px;
    color: $color-black-65;
    font-size: 16px;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -8px;
      height: 16px;
      width: 4px;
      background: $color-main;
    }
  }

  .v-exhibits-card{
    margin-bottom: 24px;
  }
}
.productTipsDialog{
  >>>.el-dialog__header{
    background $color-main 
    span, .el-dialog__close{
      color #fff
    }
  }
  .header-title{
    background $color-main 
    color #fff
  }
  .dialogConcant{
    padding 104px 120px 183px 120px
    >>> .el-button{
      margin-left 15px
    }
    p{
      line-height 20px
    }
  }
  .dialogConcantDiv{
    color $color-black-65
    font-size 14px
    margin-top 35px  
    >>> .el-input{
      width 75%
      margin-top 8px
    }
    .dialogConcantP{
      width 75%
      text-align: right;
      margin-top 8px;
      color: $color-main;
      cursor:pointer
    }
  }
}
</style>
